<template>
    <div class="wrapper">
        <v-card class="billing" outlined>
            <v-card-title class="page-heading primary minh60">
                {{ $t('general.billing') }}
            </v-card-title>

            <v-card-text class="page-content">
                <template v-if="locale === 'me' || locale === 'sr'">
                    <v-alert
                        v-if="amountDue > 0"
                        class="my-4 text-subtitle-1"
                        prominent
                        color="error"
                        type="error"
                        icon="fas fa-exclamation-circle"
                        text
                    >
                        <div v-if="showInvoices">
                            <span>{{ $t('subscription.debt_amount', { value: Money.parse(amountDue).toFormat(), software: isAllegra ? 'Allegra' : 'Aria' }), }}</span>
                            <br>
                            <span v-if="amountDue > 2">{{ $t('subscription.debt_settle') }}</span>
                        </div>
                        <div v-else>
                            <span>{{ $t('subscription.debt_settle_reseller', { software: isAllegra ? 'Allegra' : 'Aria' }) }} </span>
                        </div>
                    </v-alert>

                    <v-alert
                        v-else
                        class="my-4 text-subtitle-1"
                        prominent
                        color="success"
                        type="success"
                        text
                    >
                        {{ $t('subscription.debt_settle_success') }}
                    </v-alert>

                    <v-simple-table v-if="showInvoices">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">{{ $t('general.date') }}</th>
                                    <th class="text-left">{{ $t('general.period') }}</th>
                                    <th class="text-left">{{ $t('general.amount') }}</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(invoice, index) in invoices" :key="index">
                                    <td>{{ invoice.created_at | date }}</td>
                                    <td>
                                        <div v-if="moment(invoice.billing_end_date).diff(moment(invoice.billing_start_date), 'days') > 31">
                                            {{ invoice.billing_start_date | date }} -
                                            {{ invoice.billing_end_date | date }}
                                        </div>
                                        <div v-else>
                                            {{ $t(`months.${moment(invoice.billing_start_date).format('MMMM').toLowerCase()}`) }},
                                            {{ moment(invoice.billing_start_date).format('YYYY') }}
                                        </div>
                                    </td>
                                    <td>{{ Money.parse(invoice.amount_with_taxes).toFormat() }}</td>
                                    <td>
                                        <a target="_blank" :href="invoice.path">{{ $tc('general.receipt', 1) }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </template>

                <template v-else>
                    <v-alert
                        class="my-7 text-subtitle-1"
                        prominent
                        color="primary"
                        type="info"
                        text
                    >
                        {{ $t('subscription.next_payment_scheduled') }}
                        {{ (tenant.subscription ? tenant.subscription.p_next_bill_date : tenant.trial_ends_at) | date }}
                    </v-alert>

                    <template v-if="tenant.subscription">
                        <v-divider />

                        <v-simple-table >
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">{{ $t('general.date') }}</th>
                                        <th class="text-left">{{ $t('general.description') }}</th>
                                        <th class="text-left">{{ $t('general.paid') }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(payment, index) in tenant.subscription.payments" :key="payment.id">
                                        <td>{{ payment.p_event_time | dateTime }}</td>
                                        <td>{{ payment.p_order_id }}</td>
                                        <td>{{ payment.p_currency }} {{ payment.p_earnings }}</td>
                                        <td>
                                            <a target="_blank" :href="payment.p_receipt_url">{{ $tc('general.receipt', 1) }}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { loadData } from '@/views/shared/loadPageData';
import ApiService from '@/services/ApiService';

export default {
    components: {
    },

    created() {
        loadData('/admin/load/billing').then(data => this.onDataLoaded(data));
    },

    data() {
        return {
            invoices: [],
            amountDue: 0,
            showInvoices: false,
        };
    },

    methods: {
        /**
         * Load initial data
         */
        onDataLoaded(data) {
            this.invoices = data.invoices;
            this.amountDue = data.amount_due;
            this.showInvoices = data.show_invoices;
        },
    }
};
</script>

<style lang="scss" scoped>
.billing {
    max-width: 600px;

    .page-heading {
        padding: 12px 16px;
        color: white;
        font-size: 16px;
        word-break: break-word;
    }
}
</style>
